import { render, staticRenderFns } from "./patientDetail.vue?vue&type=template&id=0bed522e&scoped=true&"
import script from "./patientDetail.vue?vue&type=script&lang=js&"
export * from "./patientDetail.vue?vue&type=script&lang=js&"
import style0 from "./patientDetail.vue?vue&type=style&index=0&id=0bed522e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bed522e",
  null
  
)

export default component.exports